import { render, staticRenderFns } from "./PedidosColetados.vue?vue&type=template&id=74a5db7e&scoped=true"
import script from "./PedidosColetados.vue?vue&type=script&lang=js"
export * from "./PedidosColetados.vue?vue&type=script&lang=js"
import style0 from "./PedidosColetados.vue?vue&type=style&index=0&id=74a5db7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5db7e",
  null
  
)

export default component.exports